import React from "react";
import { TextField } from "@mui/material";
import { Field } from "react-final-form";
import { TextFormFieldProps } from "../common/components/FormFields/TextFormField";
import { FormFieldWrapper } from "../common/components/FormFields/FormFieldWrapper";

/** OTL fields show API validation failures without changing other forms. */
export function OtlTextFormField({
  name,
  icon,
  noIcon,
  forceError,
  value,
  helperText,
  ...props
}: TextFormFieldProps) {
  return (
    <FormFieldWrapper icon={icon} noIcon={noIcon}>
      <Field
        name={name}
        validate={(v) =>
          props.required && !String(v ?? "").trim()
            ? "This field is required"
            : undefined
        }
      >
        {({ input, meta }) => {
          const error =
            (meta.touched || meta.submitFailed) &&
            (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError));
          return (
            <TextField
              {...props}
              {...input}
              fullWidth
              error={Boolean(error || forceError)}
              helperText={error || helperText}
              minRows={props.multiline ? 3 : undefined}
              maxRows={props.multiline ? 5 : undefined}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
}
